import { observer } from 'mobx-react';
import { ExperienceResource } from '../../../../../Types';
import ExperienceListCompetency from './ExperienceListCompetency';

interface Props {
  experienceResource: ExperienceResource;
}

function ExperienceContent({ experienceResource }: Props) {
  return (
    <div className="flex flex-wrap gap-x-3 gap-y-1 empty:hidden sm:gap-x-6">
      <ExperienceListCompetency experienceResource={experienceResource} />
    </div>
  );
}

export default observer(ExperienceContent);
